
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 268.94 234.86"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M240.79 139.25l23.33-102A5.23 5.23 0 00259 30.8H59.34L54.67 7.12a5.23 5.23 0 00-5.13-4.22H9.93a5.24 5.24 0 100 10.47h35.3l33 167.42a5.35 5.35 0 00.28.91 28.71 28.71 0 1041.28 3.3h71.86a28.76 28.76 0 1022.27-10.57c-.77 0-1.54 0-2.3.1H99.3c-.57 0-1.15-.06-1.73-.06s-1.15 0-1.72.06h-8.14l-6.16-31.22h154.14a5.23 5.23 0 005.1-4.06zm-125 63.95A18.25 18.25 0 1196.46 185h2.22a18.26 18.26 0 0117.14 18.2zm116.39 0A18.29 18.29 0 11212 185h2.29a4.89 4.89 0 00.66 0 18.3 18.3 0 0117.26 18.2zM80.14 132.85l-18-91.58h190.31l-20.93 91.58z"}})])
          )
        }
      }
    